import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom'; 
import SearchInput from "../../components/SearchInput"; 
import { authFetch } from "../../utils/api";
import "../../styles/admin/aseguradoras.css";

export default function Aseguradoras() {
  const [busqueda, setBusqueda] = useState("");
  const [aseguradoras, setAseguradoras] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);

  const navigate = useNavigate(); 

  useEffect(() => {
    setLoading(true); 
    setError(null);
    
    authFetch('/api/agencia/tipo/aseguradora')
      .then((res) => {
        if (!res.ok) { 
          throw new Error('Error al cargar aseguradoras: ' + res.statusText);
        }
        return res.json();
      })
      .then((data) => {
        setAseguradoras(data);
        setLoading(false); 
      })
      .catch((err) => { 
        setError(err.message);
        setAseguradoras([]);
        setLoading(false); 
      }); 
  }, []); 

  const filtradas = useMemo(() => {
    const q = busqueda.trim().toLowerCase();
    if (!q) return aseguradoras; 
    return aseguradoras.filter((a) => 
      [a.nombre, a.telefono, a.correoElectronico]
        .filter(Boolean) 
        .some((v) => v.toLowerCase().includes(q))
    );
  }, [aseguradoras, busqueda]); 


  const handleAgregar = () => {
    navigate('/admin/aseguradoras/agregar');
  };

  const handleEditar = (aseguradora) => {
    navigate(`/admin/aseguradoras/editar/${aseguradora.id}`);
  };


  const handleDelete = async (aseguradora) => {
    const confirmacion = window.confirm(
      `¿Estás seguro de que deseas eliminar la aseguradora "${aseguradora.nombre}"?`
    );

    if (!confirmacion) {
      return;
    }

    try {

      const response = await authFetch(`/api/agencia/${aseguradora.id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('No se pudo eliminar la aseguradora.');
      }
      
      setAseguradoras(prevAseguradoras => 
        prevAseguradoras.filter(a => a.id !== aseguradora.id)
      );

      alert('Aseguradora eliminada exitosamente.');

    } catch (err) {
      alert(`Error al eliminar: ${err.message}`);
    }
  };

  return (
    <main className="aseg-main">
      <div className="aseg-header">
        <h1 className="aseg-title">Aseguradoras</h1>
        <button type="button" className="aseg-btn" onClick={handleAgregar}>
          Agregar Aseguradora
        </button>
      </div>

      <SearchInput
        placeholder="Buscar aseguradoras"
        value={busqueda}
        onChange={(e) => setBusqueda(e.target.value)}
      />
      
      {loading && <p>Cargando aseguradoras...</p>}
      
      {error && <p style={{ color: '#e11d48' }}>Error: {error}</p>}

      {!loading && !error && (
        <section className="aseg-card">
          <div className="aseg-table-wrapper">
            <table className="aseg-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Teléfono</th>
                  <th>Correo electrónico</th>
                  <th className="col-acciones">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {filtradas.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="aseg-empty">
                      {busqueda
                        ? `No hay resultados para “${busqueda}”.`
                        : "No hay aseguradoras registradas."}
                    </td>
                  </tr>
                ) : (
                  filtradas.map((a) => (
                    <tr key={a.id}> 
                      <td>{a.nombre}</td>
                      <td>{a.telefono}</td>
                      <td className="td-email">{a.correoElectronico}</td>
                      <td className="td-acciones">

                        <button
                          type="button"
                          className="aseg-link"
                          onClick={() => handleEditar(a)}
                        >
                          Editar
                        </button>

                        <button
                          type="button"
                          className="aseg-link"
                          style={{ marginLeft: '8px' }}
                          onClick={() => handleDelete(a)}
                        >
                          Borrar
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </section>
      )}
    </main>
  );
}